export { tenantRequestListScreen, tenantRequestDetailScreen } from './tenant-request.screen';
export { tenantRequestListSearch, tenantRequestDetailSearch } from './tenant-request.search';
export { loadTenantRequestMessages } from './tenant-request.catalog';
export const loadTenantRequestScreens = () => import('./screens');

/** Os guias das telas para o Luy (U46), sob demanda. */
export const loadTenantRequestGuides = () => import('./tenant-request.guide');
